import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth.module'
import Crew from './modules/crew.module'
import Guest from './modules/guest.module'
import Pagination from './modules/pagination.module'
import Mailing from './modules/mailing.module'
import FileUpload from './modules/file-upload.module'
import CrewEndorsement from './modules/endorsement.module'
import Remarks from './modules/remarks.module'
import Reservation from './modules/reservation.module'
import CrewBooking from './modules/crewBooking.module'
import Report from './modules/report.module.js'

import GuestBooking from './modules/guestBooking.module'

import HotelSettings from './modules/settings/hotels.setting.module'
import FloorSettings from './modules/settings/floors.setting.module'
import RoomSettings from './modules/settings/rooms.setting.module'
import BedSettings from './modules/settings/beds.setting.module'

import Account from './modules/account.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    Crew,
    Guest,
    Pagination,
    Mailing,
    FileUpload,
    CrewEndorsement,
    HotelSettings,
    FloorSettings,
    RoomSettings,
    BedSettings,
    Remarks,
    Reservation,
    CrewBooking,
    Report,
    GuestBooking,
    Account
  }
})
